var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('a',{staticClass:"info-link",on:{"click":function($event){_vm.show = true}}},[_vm._v(_vm._s(_vm._f("translation")('More info')))]),_c('info-modal',{attrs:{"show":_vm.show},on:{"input":function($event){_vm.show = false}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }